type QueryValue = string | number | boolean | null | undefined;

/** Append query parameters, skipping empty values and `false` flags (the API defaults). */
export function withQuery(path: string, params: Record<string, QueryValue>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "" || value === false) continue;
    search.set(key, String(value));
  }
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}

export function segment(id: string): string {
  return encodeURIComponent(id);
}

/** Mutation variables for create-or-update: `existing` present means PUT with If-Match. */
export type SaveVariables<Input> = {
  input: Input;
  existing?: { id: string; version: number };
};

export type ArchiveVariables = { id: string; archived: boolean; version: number };

/** Fields every editable record returns. */
export type Versioned = {
  id: string;
  version: number;
  created_at: string;
  updated_at: string;
};
